<header class="o-view-header page-header g-0">
  <div class="c-view-title">
    <h1 class="alpha" *ngIf="bibliographicResource.title">
      {{ bibliographicResource.title }}
    </h1>
  </div>
  <div class="c-view-actions">
    <div class="c-view-actions__wrapper">
      <a
        [href]="resourceEditUrl"
        class="btn btn-default btn-lg qa-edit-resource"
        *ngIf="canEditResource"
        i18n="@@resource-btn-editMetadata"
        >Edit metadata</a
      >

      <a
        [href]="resourceExportUrl"
        class="btn btn-default btn-lg qa-export-citation"
        i18n="@@resource-btn-exportCitation"
      >
        Export citation
      </a>
    </div>
  </div>
</header>

<rl-resource-details
  [bibliographicResource]="bibliographicResource"
  [resourceImage]="resourceImage"
  [onlineResource]="onlineResource"
></rl-resource-details>
